import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { EngagementService } from '../../shared/services/engagement.service';
import { EngagementModel } from '../models/engagement.model';
@UntilDestroy()
@Component({
  selector: 'eid-mobile-funded-accounts',
  templateUrl: './mobile-funded-accounts.component.html',
  styleUrls: ['./mobile-funded-accounts.component.scss']
})
export class MobileFundedAccountsComponent {
  public engagement$: Observable<EngagementModel>;

  constructor(private engagementService: EngagementService, private location: Location) {
    this.engagement$ = this.engagementService.getEngagementData();
  }

  back(): void {
    this.location.back();
  }
}
